export default {
  steps: {
    0: {
      title: 'Fii un client fidel',
      description: 'Vizualizați istoricul comenzilor și recomandați cu o singură atingere.',
    },
    1: {
      title: 'Obțineți recompense',
      description: 'Urmăriți punctele și răscumpărați recompensele salvate din portofel.',
    },
    2: {
      title: 'Comandați în avans',
      description: 'Găsiți cea mai apropiată locație și plasați o comandă mai rapid ca niciodată.',
    },
  },
  buttons: {
    skip: 'Omiteți',
  },
};
